import {
    DEFAULT_SIGNED_DOCUMENT_DISPLAY_NAME,
    DEFAULT_UNSIGNED_DOCUMENT_DISPLAY_NAME,
} from '../constants';

export function displayNameToFilePrefix(displayName: string): string {
    return displayName
        .trim()
        .replace(/\s+/g, '_')
        .replace(/[^a-zA-Z0-9_-]/g, '');
}

export function buildUnsignedRetainerPdfFileName(documentDisplayName: string | null): string {
    const label = documentDisplayName ?? DEFAULT_UNSIGNED_DOCUMENT_DISPLAY_NAME;
    return `${displayNameToFilePrefix(label)}.pdf`;
}

export function buildSignedRetainerPdfFileName(
    documentDisplayName: string | null,
    clientName: string,
): string {
    const label = documentDisplayName ?? DEFAULT_SIGNED_DOCUMENT_DISPLAY_NAME;
    const prefix = displayNameToFilePrefix(label);
    const cleanClientName = clientName.replace(/ /g, '_');
    return `${prefix}_${cleanClientName}.pdf`;
}
